/*
  Deletes the cookie which has the name of 'cname' variable
*/

export function deleteCookie(cname) {
  document.cookie = cname+'=; Max-Age=-99999999;';
}